import { __assign, __awaiter, __generator, __values } from "tslib";
import { DetailValueSource } from '@ekuaibao/ekuaibao_types';
import { app as api } from '@ekuaibao/whispered';
import { getV } from '@ekuaibao/lib/lib/help';
import { array2object, isNumber, isObject, isString } from '@ekuaibao/helpers';
import { MoneyMath } from '@ekuaibao/money-math';
import { INVOICE_TYPE } from '@ekuaibao/lib/lib/enums';
import { formatMoneyWithDiffCurrency, foreignConversionStandard, getAcountKey, isStandardCurrencyDiff, standardValueMoney } from './misc';
import { getDisableStateByInvoiceID, getMarkStateByInvoiceID, getOriginalFileDownload } from '../plugins/bills/bills.action';
import { showMessage } from '@ekuaibao/show-util';
import Big from 'big.js';
import { cloneDeep } from 'lodash';
import { initBudgetCurrentInfo } from '../components/utils/fnCurrencyObj';
import { getBoolVariation, enableTaxAmountOptimization } from './featbit';
import { getBillEditPerfOptimizations, enableForeignMoneyOptimization, enableDewuUiUpdate } from './featbit/feat-switch';
import moment from 'moment';
var InvoiceMappingValue = (function () {
    function InvoiceMappingValue() {
        var _this = this;
        this.originalFileDownload = function (invoices) { return __awaiter(_this, void 0, void 0, function () {
            var DIGITAL_ORIGINAL_FILE, digitalInvoices, invoiceIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        DIGITAL_ORIGINAL_FILE = (api.getState()['@common'].powers || {}).DIGITAL_ORIGINAL_FILE;
                        digitalInvoices = invoices.filter(function (item) {
                            var type = getV(item, 'master.form.E_system_发票主体_发票类别', '');
                            var isFullDigital = [
                                'FULL_DIGITAl_SPECIAL',
                                'FULL_DIGITAl_NORMAL',
                                'ELECTRONIC_TRAIN_INVOICE',
                                'ELECTRONIC_AIRCRAFT_INVOICE',
                                'ELECTRONIC_PAPER_CAR',
                                'ELECTRONIC_PAPER_FEE'
                            ].includes(type);
                            return isFullDigital;
                        }, []);
                        if (!(DIGITAL_ORIGINAL_FILE && digitalInvoices.length)) return [3, 2];
                        invoiceIds = digitalInvoices.map(function (v) { return v.master.id; });
                        return [4, getOriginalFileDownload({ invoiceIds: invoiceIds }).catch(function () { })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        this.getTotalTaxAmount = function (invoiceList) {
            if (invoiceList === void 0) { invoiceList = []; }
            var currency = (api.getState()['@bills'].dimentionCurrencyInfo || {}).currency;
            if (!Array.isArray(invoiceList) || !invoiceList.length) {
                return standardValueMoney(0, currency);
            }
            var taxAmount = invoiceList.reduce(function (total, item) {
                var taxAmount = (item || {}).taxAmount;
                var money = standardValueMoney(taxAmount.standard || 0, currency);
                money = new MoneyMath(taxAmount || 0).add(total || 0).value;
                return money;
            }, standardValueMoney(0, currency));
            return taxAmount || standardValueMoney(0, currency);
        };
    }
    InvoiceMappingValue.prototype.invoice2Detail = function (param) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var feeType, invoices, _d, specification, isBatch, _e, isImportInvoice, _f, attachmentList, currentFeeTypeForm, billData, billSpecification, KA_DISABLE_INVOICE, arr_1, disableInfoResult, markInfoResult, _g, components, rule2InvoiceValue, feeTypeForm, invoiceIds, formData;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!!this.invoiceRuleMap) return [3, 2];
                        return [4, this.lazy()];
                    case 1:
                        _h.sent();
                        _h.label = 2;
                    case 2:
                        feeType = param.feeType, invoices = param.invoices, _d = param.specification, specification = _d === void 0 ? {} : _d, isBatch = param.isBatch, _e = param.isImportInvoice, isImportInvoice = _e === void 0 ? false : _e, _f = param.attachmentList, attachmentList = _f === void 0 ? [] : _f, currentFeeTypeForm = param.currentFeeTypeForm, billData = param.billData, billSpecification = param.billSpecification;
                        KA_DISABLE_INVOICE = (api.getState()['@common'].powers || {}).KA_DISABLE_INVOICE;
                        return [4, this.originalFileDownload(invoices)];
                    case 3:
                        _h.sent();
                        if (!KA_DISABLE_INVOICE) return [3, 6];
                        arr_1 = [];
                        invoices.forEach(function (i) {
                            var _a;
                            if (!('disableInfo' in i) && ((_a = i.master) === null || _a === void 0 ? void 0 : _a.id)) {
                                arr_1.push(i.master.id);
                            }
                        });
                        if (!arr_1.length) return [3, 6];
                        return [4, api.dispatch(getDisableStateByInvoiceID(arr_1))];
                    case 4:
                        disableInfoResult = _h.sent();
                        return [4, getMarkStateByInvoiceID(arr_1)];
                    case 5:
                        markInfoResult = _h.sent();
                        (_a = disableInfoResult === null || disableInfoResult === void 0 ? void 0 : disableInfoResult.items) === null || _a === void 0 ? void 0 : _a.forEach(function (disable) {
                            invoices.forEach(function (i) {
                                var _a;
                                if (((_a = i.master) === null || _a === void 0 ? void 0 : _a.id) === (disable === null || disable === void 0 ? void 0 : disable.invoiceId)) {
                                    i.disableInfo = { disable: true };
                                }
                            });
                        });
                        (_b = markInfoResult === null || markInfoResult === void 0 ? void 0 : markInfoResult.items) === null || _b === void 0 ? void 0 : _b.forEach(function (mark) {
                            invoices.forEach(function (i) {
                                var _a;
                                if (((_a = i.master) === null || _a === void 0 ? void 0 : _a.id) === (mark === null || mark === void 0 ? void 0 : mark.invoiceId)) {
                                    i.markInfo = { mark: true };
                                }
                            });
                        });
                        _h.label = 6;
                    case 6:
                        _g = specification.components, components = _g === void 0 ? [] : _g;
                        return [4, this.processInvoice(invoices, components, currentFeeTypeForm)];
                    case 7:
                        rule2InvoiceValue = _h.sent();
                        feeTypeForm = this.processFieldMappingValue(components, rule2InvoiceValue, invoices);
                        feeTypeForm = this.processSummaryFields(components, feeTypeForm, rule2InvoiceValue);
                        return [4, this.processFormCityField(components, feeTypeForm)];
                    case 8:
                        feeTypeForm = _h.sent();
                        return [4, this.processEnumField(components, feeTypeForm)];
                    case 9:
                        feeTypeForm = _h.sent();
                        if (billSpecification === null || billSpecification === void 0 ? void 0 : billSpecification.id) {
                            invoiceIds = attachmentList === null || attachmentList === void 0 ? void 0 : attachmentList.map(function (it) {
                                var _a;
                                return (_a = it === null || it === void 0 ? void 0 : it.master) === null || _a === void 0 ? void 0 : _a.id;
                            });
                            (_c = api === null || api === void 0 ? void 0 : api.logger) === null || _c === void 0 ? void 0 : _c.info('在费用上添加发票', {
                                specificationId: billSpecification === null || billSpecification === void 0 ? void 0 : billSpecification.id,
                                specificationName: billSpecification === null || billSpecification === void 0 ? void 0 : billSpecification.name,
                                flowId: billData === null || billData === void 0 ? void 0 : billData.flowId,
                                code: billData === null || billData === void 0 ? void 0 : billData.code,
                                sceneName: '发票',
                                feeTypeId: feeType === null || feeType === void 0 ? void 0 : feeType.id,
                                feeTypeName: feeType === null || feeType === void 0 ? void 0 : feeType.name,
                                operateType: '添加',
                                invoiceIds: invoiceIds,
                                resultForm: feeTypeForm
                            });
                        }
                        formData = {
                            feeTypeId: feeType,
                            feeTypeForm: feeTypeForm,
                            specificationId: specification,
                            attachmentList: attachmentList
                        };
                        if (!(getBoolVariation('CYXQ-88816') && isImportInvoice)) return [3, 11];
                        return [4, api
                                .invoke('generate:DetailByAutoCalculate', { detailFormValue: formData, components: components }, true)
                                .catch(function () {
                                return formData;
                            })];
                    case 10: return [2, _h.sent()];
                    case 11:
                        if (!isBatch) return [3, 13];
                        return [4, api
                                .invoke('generate:DetailByAutoCalculate', { detailFormValue: formData, components: components }, true)
                                .catch(function () {
                                return formData;
                            })];
                    case 12: return [2, _h.sent()];
                    case 13: return [2, formData];
                }
            });
        });
    };
    InvoiceMappingValue.prototype.clearInvoicesForm = function (components) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.lazy()];
                    case 1:
                        _a.sent();
                        return [2, this.processNoInvoices(components)];
                }
            });
        });
    };
    InvoiceMappingValue.prototype.invoice2FeeTypeForm = function (invoices, components, currentFeeTypeForm) {
        if (invoices === void 0) { invoices = []; }
        return __awaiter(this, void 0, void 0, function () {
            var rule2InvoiceValue, feeTypeForm;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.invoiceRuleMap) return [3, 2];
                        return [4, this.lazy()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!invoices.length) {
                            return [2, this.processNoInvoices(components)];
                        }
                        return [4, this.processInvoice(invoices, components, currentFeeTypeForm)];
                    case 3:
                        rule2InvoiceValue = _a.sent();
                        feeTypeForm = this.processFieldMappingValue(components, rule2InvoiceValue, invoices);
                        return [4, this.processFormCityField(components, feeTypeForm)];
                    case 4:
                        feeTypeForm = _a.sent();
                        return [4, this.processEnumField(components, feeTypeForm)];
                    case 5:
                        feeTypeForm = _a.sent();
                        return [2, this.processSummaryFields(components, feeTypeForm, rule2InvoiceValue)];
                }
            });
        });
    };
    InvoiceMappingValue.prototype.lazy = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, items;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, api.invokeService('@invoice-manage:get:invoice:mapping:rule')];
                    case 1:
                        _a = (_b.sent()).items, items = _a === void 0 ? [] : _a;
                        this.invoiceRules = items;
                        this.invoiceRuleMap = array2object(items, 'entityId');
                        return [2];
                }
            });
        });
    };
    InvoiceMappingValue.prototype.processInvoice = function (invoices, components, currentFeeTypeForm) {
        return __awaiter(this, void 0, void 0, function () {
            var invoiceMapList, invoiceEntityKeys, baseDataPropertiesMap, rule2InvoiceValue, staffsOptimization, invoiceEntityKeys_1, invoiceEntityKeys_1_1, entityId, invoiceList, invoiceRule, invoiceListLength, _loop_1, this_1, curIndex, e_1_1;
            var e_1, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        invoiceMapList = {};
                        invoiceEntityKeys = [];
                        baseDataPropertiesMap = api.getState('@common.globalFields.baseDataPropertiesMap') || {};
                        invoices.forEach(function (invoice) {
                            var list = invoiceMapList[invoice.master.entityId];
                            if (!list) {
                                list = [];
                                invoiceMapList[invoice.master.entityId] = list;
                                invoiceEntityKeys.push(invoice.master.entityId);
                            }
                            list.push(invoice);
                        });
                        rule2InvoiceValue = {};
                        staffsOptimization = getBillEditPerfOptimizations().staffsOptimization;
                        if (!staffsOptimization) return [3, 11];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, 9, 10]);
                        invoiceEntityKeys_1 = __values(invoiceEntityKeys), invoiceEntityKeys_1_1 = invoiceEntityKeys_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!invoiceEntityKeys_1_1.done) return [3, 7];
                        entityId = invoiceEntityKeys_1_1.value;
                        invoiceList = invoiceMapList[entityId];
                        invoiceRule = this.invoiceRuleMap[entityId];
                        invoiceRule.rules = this.mergeRules(invoiceRule === null || invoiceRule === void 0 ? void 0 : invoiceRule.rules, this.addDefaultRules(entityId));
                        invoiceListLength = invoiceList.length;
                        _loop_1 = function (curIndex) {
                            var invoice, detailResult, staffs, staffList, res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        invoice = invoiceList[curIndex];
                                        detailResult = void 0;
                                        if (invoice.details && invoice.details.length) {
                                            detailResult = this_1.processDetail(invoice);
                                        }
                                        staffs = new Set();
                                        invoiceRule.rules.forEach(function (rule) {
                                            var globalField = baseDataPropertiesMap[rule.detailField];
                                            var entity = getV(globalField, 'dataType.entity');
                                            var current = invoice.master.form[rule.mappingValue];
                                            if (entity === 'organization.Staff' && current && rule.mappingType === DetailValueSource.INVOICEINFO) {
                                                staffs.add(current);
                                            }
                                        });
                                        staffList = [];
                                        if (!(staffs.size > 0)) return [3, 2];
                                        return [4, api.invokeService('@common:search:staffs', { nameList: Array.from(staffs) })];
                                    case 1:
                                        res = _a.sent();
                                        staffList = (res === null || res === void 0 ? void 0 : res.items) || [];
                                        _a.label = 2;
                                    case 2:
                                        rule2InvoiceValue = this_1.conver2DetailByRule(invoice, detailResult, invoiceRule, rule2InvoiceValue, baseDataPropertiesMap, curIndex, invoiceList.length, components, currentFeeTypeForm, staffList);
                                        return [2];
                                }
                            });
                        };
                        this_1 = this;
                        curIndex = 0;
                        _b.label = 3;
                    case 3:
                        if (!(curIndex < invoiceListLength)) return [3, 6];
                        return [5, _loop_1(curIndex)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        curIndex++;
                        return [3, 3];
                    case 6:
                        invoiceEntityKeys_1_1 = invoiceEntityKeys_1.next();
                        return [3, 2];
                    case 7: return [3, 10];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3, 10];
                    case 9:
                        try {
                            if (invoiceEntityKeys_1_1 && !invoiceEntityKeys_1_1.done && (_a = invoiceEntityKeys_1.return)) _a.call(invoiceEntityKeys_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7];
                    case 10: return [3, 12];
                    case 11:
                        invoiceEntityKeys.forEach(function (entityId) {
                            var invoiceList = invoiceMapList[entityId];
                            var invoiceRule = _this.invoiceRuleMap[entityId];
                            invoiceRule.rules = _this.mergeRules(invoiceRule === null || invoiceRule === void 0 ? void 0 : invoiceRule.rules, _this.addDefaultRules(entityId));
                            invoiceList.forEach(function (invoice, curIndex) {
                                var detailResult;
                                if (invoice.details && invoice.details.length) {
                                    detailResult = _this.processDetail(invoice);
                                }
                                rule2InvoiceValue = _this.conver2DetailByRule(invoice, detailResult, invoiceRule, rule2InvoiceValue, baseDataPropertiesMap, curIndex, invoiceList.length, components, currentFeeTypeForm);
                            });
                        });
                        _b.label = 12;
                    case 12: return [2, rule2InvoiceValue];
                }
            });
        });
    };
    InvoiceMappingValue.prototype.conver2DetailByRule = function (invoice, detailResult, ruleItem, rule2InvoiceValue, globalFieldMap, curIndex, invoiceListLength, components, currentFeeTypeForm, staffList) {
        var _this = this;
        var staffsOptimization = getBillEditPerfOptimizations().staffsOptimization;
        return ruleItem.rules.reduce(function (result, rule) {
            var globalField = globalFieldMap[rule.detailField];
            var type = getV(globalField, 'dataType.type');
            if (rule.detailField === 'sumAmountAndTax') {
                type = 'money';
            }
            var entity = getV(globalField, 'dataType.entity');
            var prev = result[rule.detailField];
            var current = invoice.master.form[rule.mappingValue];
            if (rule.mappingType === DetailValueSource.INVOICEDETAIL) {
                current = detailResult === null || detailResult === void 0 ? void 0 : detailResult[rule.mappingValue];
            }
            if (rule.mappingValue === 'E_税额' && invoice.taxAmount) {
                current = invoice.taxAmount;
            }
            if (rule.mappingValue === 'E_税率' && invoice.taxRate !== undefined) {
                current = invoice.taxRate;
            }
            if (rule.mappingType === DetailValueSource.FIXED) {
                current = rule.mappingValue;
            }
            if (type === 'money') {
                if (rule.detailField === 'amount' && getV(invoice, 'approveAmount') && getV(invoice, 'comment')) {
                    result[rule.detailField] = _this.processMoney(getV(invoice, 'approveAmount'), prev, rule.mappingValue, false, rule.detailField, currentFeeTypeForm);
                    return result;
                }
                result[rule.detailField] = _this.processMoney(current, prev, rule.mappingValue, detailResult, rule.detailField, currentFeeTypeForm);
                return result;
            }
            if (type === 'number') {
                result[rule.detailField] = _this.processNumber(current, prev, rule.mappingValue, detailResult, invoice.taxRate);
                return result;
            }
            if (entity === 'basedata.city' && current && rule.mappingType === DetailValueSource.INVOICEINFO) {
                result[rule.detailField] = { isFixed: false, value: current };
                return result;
            }
            if (entity === 'organization.Staff' && current && rule.mappingType === DetailValueSource.INVOICEINFO) {
                var tempResult = Object.assign({}, __assign({}, result));
                var loginStaff = api.getState('@common.userinfo.staff');
                var activesStaffs = staffsOptimization && staffList ? staffList : api.getState('@common.staffsVisibility');
                var showTipMessage_1 = false;
                components.map(function (component) {
                    if (component.field == rule.detailField)
                        showTipMessage_1 = true;
                });
                var filterStaff = (activesStaffs === null || activesStaffs === void 0 ? void 0 : activesStaffs.filter(function (staff) {
                    return staff.name === current;
                })) || [];
                if ((filterStaff === null || filterStaff === void 0 ? void 0 : filterStaff.length) > 1) {
                    if ((loginStaff === null || loginStaff === void 0 ? void 0 : loginStaff.name) == filterStaff[0].name) {
                        tempResult[rule.detailField] = loginStaff;
                    }
                    else {
                        tempResult[rule.detailField] = '';
                        if (curIndex + 1 == invoiceListLength && showTipMessage_1)
                            showMessage.error(i18n.get('在该企业找到多位同名乘车人员，请手动选择'));
                    }
                }
                else if ((filterStaff === null || filterStaff === void 0 ? void 0 : filterStaff.length) == 1) {
                    tempResult[rule.detailField] = filterStaff[0];
                }
                else {
                    tempResult[rule.detailField] = '';
                    if (curIndex + 1 == invoiceListLength && showTipMessage_1)
                        showMessage.error(i18n.get('在该企业未找到对应乘车人员'));
                }
                return tempResult;
            }
            if (rule.detailField === 'invoiceType' && current && rule.mappingType === DetailValueSource.INVOICEINFO) {
                result[rule.detailField] = { isFixed: false, value: current };
                return result;
            }
            var ENUM_VALUE_TO_TEXT = api.getState('@common').powers.ENUM_VALUE_TO_TEXT;
            if (ENUM_VALUE_TO_TEXT &&
                type === 'text' &&
                rule.mappingValue === 'E_system_发票主体_发票类别' &&
                current &&
                rule.mappingType === DetailValueSource.INVOICEINFO) {
                result[rule.detailField] = INVOICE_TYPE()[current];
                return result;
            }
            var curFeild = components.find(function (component) { return component.field === rule.detailField; });
            if (type === 'date' && curFeild && current) {
                if (curFeild.dateTimeType === 'YEAR_MONTH') {
                    current = moment(current || new Date()).startOf('month').valueOf();
                }
                else if (curFeild.dateTimeType === 'YEAR_MONTH_DAY_TIME') {
                    current = current;
                }
                else {
                    current = moment(current || new Date()).startOf('day').valueOf();
                }
            }
            result[rule.detailField] = current;
            return result;
        }, rule2InvoiceValue);
    };
    InvoiceMappingValue.prototype.processDetail = function (invoice) {
        var deduction = invoice.master.form['E_是否抵扣'];
        var masterEntityId = invoice.master.entityId;
        return invoice.details.reduce(function (result, current, currentIndex) {
            var _a;
            var unitPriceKey = "E_" + current.entityId + "_\u5355\u4EF7";
            var taxAmountKey = "E_" + current.entityId + "_\u7A0E\u989D";
            var noTaxAmountKey = "E_" + current.entityId + "_\u91D1\u989D";
            var taxRateKey = "E_" + current.entityId + "_\u7A0E\u7387";
            var detail = {};
            for (var key in current.form) {
                if ([unitPriceKey, taxAmountKey, noTaxAmountKey].includes(key)) {
                    var money = result[key] || 0;
                    var sumMoney = new MoneyMath(money).add(current.form[key] || 0).value;
                    detail[key] = sumMoney;
                }
                else if (key === taxRateKey) {
                    var currentTaxRate = current.form[key];
                    var taxRate = result.hasOwnProperty(key) ? result[key] : currentTaxRate;
                    if (taxRate !== undefined && taxRate !== currentTaxRate) {
                        taxRate = undefined;
                    }
                    detail[key] = taxRate;
                }
                else {
                    detail[key] = currentIndex === 0 ? current.form[key] : result[key];
                }
            }
            var sumTaxAmount = detail[taxAmountKey];
            var sumNoTaxAmount = detail[noTaxAmountKey];
            var sumAmountAndTax = new MoneyMath(sumTaxAmount).add(sumNoTaxAmount).value;
            result = __assign(__assign({}, detail), (_a = {}, _a["E_\u7A0E\u7387"] = detail[taxRateKey], _a["E_" + masterEntityId + "_\u7A0E\u989D"] = sumTaxAmount, _a["E_\u4E0D\u8BA1\u7A0E\u91D1\u989D"] = sumNoTaxAmount, _a["E_" + masterEntityId + "_\u4EF7\u7A0E\u5408\u8BA1"] = sumAmountAndTax, _a.sumAmountAndTax = sumAmountAndTax, _a));
            if (deduction) {
                result["E_\u7A0E\u989D"] = invoice.taxAmount || sumTaxAmount;
            }
            return result;
        }, {});
    };
    InvoiceMappingValue.prototype.processMoney = function (current, prev, sourceField, detailResult, detailField, currentFeeTypeForm) {
        var _a, _b, _c;
        if (prev === void 0) { prev = standardValueMoney(0); }
        var dimensionCurrency = (_a = api.getState()['@bills']) === null || _a === void 0 ? void 0 : _a.dimentionCurrencyInfo;
        var hasForeignNumCode = (prev === null || prev === void 0 ? void 0 : prev.foreignNumCode) && (current === null || current === void 0 ? void 0 : current.foreignNumCode);
        if (detailResult) {
            current = detailResult[sourceField] || current;
        }
        if (!!current && isStandardCurrencyDiff(current, standardValueMoney(0, dimensionCurrency === null || dimensionCurrency === void 0 ? void 0 : dimensionCurrency.currency))) {
            if (sourceField === null || sourceField === void 0 ? void 0 : sourceField.startsWith('E_system_海外发票')) {
                current = foreignConversionStandard(current);
            }
            else {
                current = formatMoneyWithDiffCurrency(current, standardValueMoney(0, dimensionCurrency === null || dimensionCurrency === void 0 ? void 0 : dimensionCurrency.currency), dimensionCurrency === null || dimensionCurrency === void 0 ? void 0 : dimensionCurrency.rates);
            }
        }
        var money;
        if (hasForeignNumCode && (current === null || current === void 0 ? void 0 : current.foreignNumCode) !== (prev === null || prev === void 0 ? void 0 : prev.foreignNumCode)) {
            var standardAaddForeign = new Big(current.standard).plus(new Big(prev.standard));
            var standard = standardAaddForeign.toFixed(Number(current.standardScale));
            var foreign = standardAaddForeign.div(current.rate).toFixed(Number(current.standardScale));
            money = __assign(__assign({}, current), { foreign: foreign.valueOf(), standard: standard });
        }
        else if (hasForeignNumCode && (current === null || current === void 0 ? void 0 : current.foreign) && (current === null || current === void 0 ? void 0 : current.foreignStrCode)) {
            var foreign = new Big(prev.foreign || new Big(prev.standard).div(current.rate)).plus(current.foreign);
            var standard = new Big(foreign).times(current.rate).toFixed(Number(current.standardScale));
            money = __assign(__assign({}, current), { foreign: foreign.valueOf(), standard: standard });
        }
        else if (!(prev === null || prev === void 0 ? void 0 : prev.standard) && (current === null || current === void 0 ? void 0 : current.foreign)) {
            money = current;
        }
        else {
            money = new MoneyMath(prev).add(current).value;
        }
        if ((dimensionCurrency === null || dimensionCurrency === void 0 ? void 0 : dimensionCurrency.currency) &&
            !money.foreignStrCode &&
            (money === null || money === void 0 ? void 0 : money.standardNumCode) !== ((_b = dimensionCurrency.currency) === null || _b === void 0 ? void 0 : _b.numCode)) {
            money = standardValueMoney(money.standard, dimensionCurrency.currency);
        }
        if (money.foreignStrCode && money.foreign) {
            money.foreign = Number(money.foreign).toFixed(Number(money.foreignScale));
        }
        var currentFieldValue = currentFeeTypeForm === null || currentFeeTypeForm === void 0 ? void 0 : currentFeeTypeForm[detailField];
        var useInvoiceAssignBudgetValue = getBoolVariation('invoice-assign-budget-money');
        if (useInvoiceAssignBudgetValue &&
            currentFeeTypeForm &&
            !currentFieldValue &&
            !!((_c = dimensionCurrency === null || dimensionCurrency === void 0 ? void 0 : dimensionCurrency.rates) === null || _c === void 0 ? void 0 : _c.length) &&
            currentFeeTypeForm.hasOwnProperty(detailField)) {
            var budgetMoney = initBudgetCurrentInfo(money, dimensionCurrency === null || dimensionCurrency === void 0 ? void 0 : dimensionCurrency.rates);
            currentFieldValue = __assign(__assign({}, money), budgetMoney);
        }
        if (currentFieldValue) {
            var moneyObj = currentFieldValue;
            if (!dimensionCurrency || typeof moneyObj !== 'object') {
                return money;
            }
            moneyObj.standard = money.standard;
            if (moneyObj.budgetStrCode &&
                moneyObj.standard !== undefined &&
                moneyObj.budgetRate &&
                Number(moneyObj.budgetRate) !== 0) {
                moneyObj.budget =
                    Number(moneyObj.standard) === 0
                        ? '0'
                        : new Big(moneyObj.standard).div(moneyObj.budgetRate).toFixed(Number(moneyObj.budgetScale));
            }
            if (moneyObj.foreignStrCode && moneyObj.standard !== undefined && moneyObj.rate && Number(moneyObj.rate) !== 0) {
                var shouldKeepForeign = enableForeignMoneyOptimization() && money.foreign !== undefined;
                if (shouldKeepForeign) {
                    moneyObj.foreign = Number(moneyObj.standard) === 0 ? '0' : money.foreign;
                    moneyObj.standard = Number(moneyObj.foreign) === 0 ? '0' : new Big(moneyObj.foreign).times(moneyObj.rate).toFixed(Number(moneyObj.standardScale));
                }
                else {
                    moneyObj.foreign =
                        Number(moneyObj.standard) === 0
                            ? '0'
                            : new Big(moneyObj.standard).div(moneyObj.rate).toFixed(Number(moneyObj.foreignScale));
                }
            }
            return __assign(__assign({}, money), moneyObj);
        }
        return money;
    };
    InvoiceMappingValue.prototype.processNumber = function (current, prev, sourceField, detailResult, taxRate) {
        if (taxRate === void 0) { taxRate = ''; }
        if (sourceField.indexOf('税率') >= 0) {
            current = detailResult ? detailResult[sourceField] : current;
            var result = prev !== undefined && current !== prev ? '' : current;
            if (isString(result) && (result === null || result === void 0 ? void 0 : result.length) && taxRate) {
                result = taxRate;
            }
            return result;
        }
        return String(Number(current) + Number(prev || 0));
    };
    InvoiceMappingValue.prototype.processFieldMappingValue = function (components, rule2InvoiceValue, invoices) {
        return components.reduce(function (result, current) {
            var value = rule2InvoiceValue[current.field];
            if (value !== undefined) {
                if (current.field === 'invoiceType' && isObject(value) && !value.isFixed) {
                    result[current.field] = invoiceTypeMapping[value.value];
                    return result;
                }
                if (current.field === 'taxRate') {
                    var rate = isNumber(value) ? String(value) : value;
                    value = rate === null || rate === void 0 ? void 0 : rate.replace('%', '');
                    value = isNaN(Number(value)) ? '0' : value;
                }
                result[current.field] = value;
                return result;
            }
            if (current.field === 'invoice') {
                result[current.field] = '1';
                return result;
            }
            if (current.field === 'invoiceForm') {
                result[current.field] = {
                    invoices: invoices,
                    type: 'exist'
                };
            }
            return result;
        }, {});
    };
    InvoiceMappingValue.prototype.processSummaryFields = function (component, feeTypeForm, rule2InvoiceValue) {
        var _this = this;
        var summaryFields = component.filter(function (line) { return getV(line, 'defaultValue.type') === 'invoiceSum'; });
        if (summaryFields.length) {
            var cloneInvoiceValue_1 = cloneDeep(rule2InvoiceValue);
            summaryFields.forEach(function (_a) {
                var _b;
                var defaultValue = _a.defaultValue, field = _a.field;
                var v = getV(defaultValue, 'value');
                var value = getAcountKey(v);
                if (v === 'taxTotal') {
                    feeTypeForm[field] = new MoneyMath(cloneInvoiceValue_1.sumAmountAndTax).value;
                }
                else if (value === 'taxAmount' && enableTaxAmountOptimization()) {
                    var taxAmount = _this.getTotalTaxAmount((_b = feeTypeForm === null || feeTypeForm === void 0 ? void 0 : feeTypeForm.invoiceForm) === null || _b === void 0 ? void 0 : _b.invoices);
                    feeTypeForm[field] = taxAmount;
                }
                else {
                    feeTypeForm[field] = cloneInvoiceValue_1[value];
                }
            });
        }
        return feeTypeForm;
    };
    InvoiceMappingValue.prototype.processNoInvoices = function (component) {
        var fields = this.invoiceRules.reduce(function (result, current) {
            return current.rules.reduce(function (ruleResult, ruleCurrent) {
                ruleResult.push(ruleCurrent.detailField);
                return ruleResult;
            }, result);
        }, []);
        var currency = (api.getState()['@bills'].dimentionCurrencyInfo || {}).currency;
        return component.reduce(function (feeTypeForm, c) {
            if (!!~fields.indexOf(c.field)) {
                feeTypeForm[c.field] = undefined;
            }
            if (enableDewuUiUpdate() && getV(c, 'defaultValue.type') === 'invoiceSum') {
                feeTypeForm[c.field] = standardValueMoney(0, currency);
            }
            return feeTypeForm;
        }, {});
    };
    InvoiceMappingValue.prototype.processFormCityField = function (components, feeTypeForm) {
        return __awaiter(this, void 0, void 0, function () {
            var valueFields, cityKeys, encodeCityKeys, _a, cityValue_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        valueFields = components.reduce(function (result, c) {
                            if (getV(c, 'type') === 'city') {
                                var city = feeTypeForm[c.field];
                                if (city && city.isFixed !== undefined && !city.isFixed) {
                                    var fields = result[city.value] || [];
                                    fields.push(c.field);
                                    result[city.value] = fields;
                                }
                            }
                            return result;
                        }, {});
                        cityKeys = Object.keys(valueFields);
                        encodeCityKeys = cityKeys.map(function (oo) { return encodeURIComponent(oo); });
                        if (!cityKeys.length) return [3, 2];
                        return [4, api.invokeService('@invoice-manage:get:invoice:city', {
                                cities: encodeCityKeys
                            })];
                    case 1:
                        _a = (_b.sent()).value, cityValue_1 = _a === void 0 ? {} : _a;
                        return [2, cityKeys.reduce(function (form, key) {
                                var value = cityValue_1[key];
                                var fields = valueFields[key];
                                fields.reduce(function (fieldForm, field) {
                                    fieldForm[field] = value ? JSON.stringify([value]) : undefined;
                                    return fieldForm;
                                }, feeTypeForm);
                                return form;
                            }, feeTypeForm)];
                    case 2: return [2, Promise.resolve(feeTypeForm)];
                }
            });
        });
    };
    InvoiceMappingValue.prototype.processEnumField = function (components, feeTypeForm) {
        return __awaiter(this, void 0, void 0, function () {
            var baseDataPropertiesMap, result, enumCodes, promises, data, items_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseDataPropertiesMap = api.getState('@common.globalFields.baseDataPropertiesMap') || {};
                        result = components.reduce(function (result, c) {
                            var globalField = baseDataPropertiesMap[c.field];
                            var entity = getV(globalField, 'dataType.entity', '') || getV(globalField, 'dataType.elemType.entity', '');
                            var value = feeTypeForm[c.field];
                            if (entity.startsWith('basedata.Enum') && isString(value)) {
                                var code = entity.split('.').pop();
                                var fields = (result[code] || { fields: [] }).fields;
                                fields.push(c.field);
                                result[code] = { fields: fields, value: value };
                            }
                            return result;
                        }, {});
                        enumCodes = Object.keys(result);
                        if (!enumCodes.length) return [3, 2];
                        promises = enumCodes.map(function (code) { return api.invokeService('@common:get:enumitems', code); });
                        return [4, Promise.all(promises)];
                    case 1:
                        data = _a.sent();
                        items_1 = data.reduce(function (result, item) {
                            result = result.concat(item.items);
                            return result;
                        }, []);
                        if (items_1.length) {
                            return [2, enumCodes.reduce(function (form, code) {
                                    var _a = result[code], fields = _a.fields, name = _a.value;
                                    var value = items_1.find(function (item) { return item.id === name || item.code === name || item.name === name; });
                                    fields.reduce(function (fieldForm, field) {
                                        fieldForm[field] = value;
                                        return fieldForm;
                                    }, feeTypeForm);
                                    return form;
                                }, feeTypeForm)];
                        }
                        _a.label = 2;
                    case 2: return [2, feeTypeForm];
                }
            });
        });
    };
    InvoiceMappingValue.prototype.addDefaultRules = function (entityId) {
        var baseRules = [
            { detailField: 'taxAmount', mappingType: 'invoiceInfo', mappingValue: 'E_税额' },
            { detailField: 'noTaxAmount', mappingType: 'invoiceInfo', mappingValue: 'E_不计税金额' }
        ];
        var defaultRulesMap = {
            system_发票主体: baseRules.concat({ detailField: 'taxRate', mappingType: 'invoiceInfo', mappingValue: 'E_税率' }, { detailField: 'sumAmountAndTax', mappingType: 'invoiceInfo', mappingValue: "E_" + entityId + "_\u4EF7\u7A0E\u5408\u8BA1" }),
            system_出租车票: baseRules.concat({ detailField: 'sumAmountAndTax', mappingType: 'invoiceInfo', mappingValue: 'E_system_出租车票_金额' }),
            system_火车票: baseRules.concat({ detailField: 'sumAmountAndTax', mappingType: 'invoiceInfo', mappingValue: 'E_system_火车票_金额' }),
            system_客运汽车发票: baseRules.concat({ detailField: 'sumAmountAndTax', mappingType: 'invoiceInfo', mappingValue: 'E_system_客运汽车发票_金额' }),
            system_航空运输电子客票行程单: baseRules.concat({
                detailField: 'sumAmountAndTax',
                mappingType: 'invoiceInfo',
                mappingValue: 'E_system_航空运输电子客票行程单_金额'
            }),
            system_过路费发票: baseRules.concat({ detailField: 'sumAmountAndTax', mappingType: 'invoiceInfo', mappingValue: 'E_system_过路费发票_金额' }),
            system_定额发票: baseRules.concat({ detailField: 'sumAmountAndTax', mappingType: 'invoiceInfo', mappingValue: 'E_system_定额发票_金额' }),
            system_其他: baseRules
        };
        return defaultRulesMap[entityId] || [];
    };
    InvoiceMappingValue.prototype.mergeRules = function (rules, toMergeRules) {
        var map = array2object(rules, 'detailField');
        return toMergeRules.reduce(function (array, rule) {
            if (!map[rule.detailField]) {
                array.push(rule);
            }
            return array;
        }, rules);
    };
    return InvoiceMappingValue;
}());
export default InvoiceMappingValue;
var invoiceTypeMapping = {
    DIGITAL_NORMAL: 'VATElectronicInvoice',
    DIGITAL_SPECIAL: 'VATElectronicSpecialInvoice',
    PAPER_NORMAL: 'VATOrdinaryInvoice',
    PAPER_SPECIAL: 'VATSpecialInvoice',
    FULL_DIGITAl_PAPER: 'FullDigitalSpecialPaper',
    FULL_DIGITAl_PAPER_NORMAL: 'FullDigitalSpecialPaperNormal',
    PAPER_CAR: 'MotorInvoice',
    PAPER_ROLL: 'VATVolumeTicket',
    PAPER_FEE: 'TollInvoice',
    BLOCK_CHAIN: 'BlockchainElectronicInvoice',
    FULL_DIGITAl_NORMAL: 'FullDigitalNormal',
    FULL_DIGITAl_SPECIAL: 'FullDigitalSpecial',
    OverseasInvoice: 'OverseasInvoice',
    ELECTRONIC_AIRCRAFT_INVOICE: 'FullDigitalAircraftInvoice',
    ELECTRONIC_TRAIN_INVOICE: 'FullDigitalTrainInvoice',
    ELECTRONIC_PAPER_CAR: 'FullDigitalMotorInvoice',
    ELECTRONIC_PAPER_FEE: 'FullTollInvoice'
};
